import { useTranslation } from 'react-i18next';
import { FaClock, FaIdCard, FaUser } from 'react-icons/fa';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { useAssignModal, useNavigate } from 'hooks';
import { consulteeIdState, showRequestExtensionState } from 'store';
import { Consultation, MenuOption } from 'types';

export const useSummaryMenuOptions = (
  consultation: Consultation | undefined
): MenuOption[] => {
  const { t } = useTranslation('consultation_summary');

  const consulteeId = useRecoilValue(consulteeIdState);

  const { navigateToDetails } = useNavigate();
  const { handleAssignConsultation } = useAssignModal();
  const setShowRequestExtension = useSetRecoilState(showRequestExtensionState);

  const options: MenuOption[] = [
    {
      label: t('case_details', 'Case details'),
      onClick: (consultationId) => consultationId && navigateToDetails(consultationId),
      icon: FaIdCard,
    },
    {
      label: t('assign', 'Assign'),
      onClick: (consultationId) => consultationId && handleAssignConsultation(consultationId),
      icon: FaUser,
    },
  ];

  if (
    consultation &&
    !consultation.hasExtensionRequest &&
    consultation.status !== 'Extension requested' &&
    consultation.assigneeId === consulteeId &&
    consultation.consultationType !== 'RPC'
  ) {
    options.push({
      label: t('request_extension', 'Request extension'),
      onClick: () => setShowRequestExtension(true),
      icon: FaClock,
    });
  }

  return options;
};
